import request from '@/config/axios'

// 电子票 - 自营模式
export const getETicketPage = (params: any) => {
  return request.get({ url: '/scenic/eticket/page', params })
}

export const getETicket = (id: number) => {
  return request.get({ url: '/scenic/eticket/get', params: { id } })
}

export const getETicketByNo = (ticketNo: string) => {
  return request.get({ url: '/scenic/eticket/get-by-no', params: { ticketNo } })
}

export const getETicketsByOrderId = (orderId: number) => {
  return request.get({ url: '/scenic/eticket/list-by-order', params: { orderId } })
}

export const refundETicket = (id: number) => {
  return request.post({ url: '/scenic/eticket/refund', params: { id } })
}

export const reportLossETicket = (id: number) => {
  return request.post({ url: '/scenic/eticket/report-loss', params: { id } })
}

export const markETicketExpired = () => {
  return request.post({ url: '/scenic/eticket/mark-expired' })
}

export const countCurrentVisitors = (routeId: number) => {
  return request.get({ url: '/scenic/eticket/current-visitors', params: { routeId } })
}

export const checkVisitorLimit = (routeId: number) => {
  return request.get({ url: '/scenic/eticket/check-limit', params: { routeId } })
}
